import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { AddonOutputDto, AddonService, StoreResponseDto } from 'src/generated_client';

@Component({
  selector: 'app-additionals',
  templateUrl: './additionals.component.html',
  styleUrls: ['./additionals.component.css']
})
export class AdditionalsComponent implements OnInit {

  displayedColumns: string[] = ['titulo', 'precio', 'opcion'];
  allAddons: AddonOutputDto[] = [];

  constructor(
    private router: Router,
    private authService: AuthService,
    public addonService: AddonService,
    private snackBar: SnackBarService
  ) { }

  storeResponse: StoreResponseDto = {} as StoreResponseDto;
  addonOutput: AddonOutputDto = {} as AddonOutputDto;

  ngOnInit(): void {

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.storeResponse = this.authService.currentUserStore();

    this.addonService.apiAddonGetAllByStoreGet(this.storeResponse.cdStore).subscribe(x => {

      this.allAddons = x;
    })
  }

  editExtra(id: number) {
    this.router.navigate(['edit-extra', id]);
  }

  addExtra() {
    this.router.navigate(['add-extra']);
  }

  deleteExtra(id: number) {

    this.addonService.apiAddonDeleteDelete(id).subscribe(response => {

      this.router.navigate(['additionals']);

      this.snackBar.openSnackBar('Se eliminó correctamente.', 'Aceptar');
    },
      (err) => {

        this.snackBar.openSnackBar(err.error.error, 'Aceptar')
      }
    )
  }
}
